import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.a`
  --width: 100%;
  --height: 80px;
  --transition-duration: ${({ theme }) => theme.style.transitionTime[400]};

  & {
    color: ${({ theme }) => theme.colors.gray[0]};
    border: 2px solid ${({ theme }) => theme.colors.gray[0]};
    // width: var(--width);
    min-height: var(--height);
    position: relative;
    overflow: hidden;
    border-radius: 16px 16px 0 16px;
    font-size: var(--fs-300);
    font-weight: 300;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-flow: row nowrap;
    padding: 24px 5%;
    transition: var(--transition-duration) opacity,
      var(--transition-duration) background-color,
      var(--transition-duration) border-color;
    // opacity: ${({ theme }) => theme.style.opacity[200]};
    // cursor: not-allowed;
  }

  &:link {
    opacity: ${({ theme }) => theme.style.opacity[900]};
    cursor: pointer;
  }

  &:link:hover {
    border-color: ${({ theme }) => theme.colors.primary[400]};
    background-color: ${({ theme }) => theme.colors.primary[400]};
  }

  &:link:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  h4 {
    font-size: var(--fs-500);
    font-weight: 500;
    line-height: normal;
  }

  p {
    line-height: normal;
  }

  & .right-container > h4 {
    margin: 0 0 0 16px;
    transition: var(--transition-duration) color;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.tertiary[400]};
    min-width: 82px;
  }

  &:link:hover .right-container > h4 {
    color: ${({ theme }) => theme.colors.gray[0]};
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        h4: {
          fontSize: ['var(--fs-50)', 'var(--fs-50)', 'var(--fs-500)'],
        },
        '&': {
          fontSize: ['var(--fs-25)', 'var(--fs-25)', 'var(--fs-500)'],
        },
      }),
    ).styles}}
`

export default Container
